import { FilterSearch } from 'components/generic';
import { useState, useEffect, Fragment } from 'react';
import Images from 'assets/Images';
import { useFetch } from 'hooks';

import './style.scss';

const FAQ = () => {
	const [downArrow, setDownArrow] = useState(null);
	const [faq, setFaqs] = useState([]);
	const api = useFetch();

	// referenceData
	const setBaseData = async () => {
		const { data } = await api({ url: 'referenceData/v1/onboarding', method: 'get' });
		setFaqs(data?.data?.find(el => el.key === 'rd_onboardingFAQs')?.value);
	};

	useEffect(() => {
		setBaseData();
	}, []);

	return (
		<div className='layout-wrap'>
			<div className='faq__header'>
				<img src={Images.loginLogo} alt='App logo' width='30px' height='30px' />
				<h4>{process.env.REACT_APP_NAME}</h4>
			</div>
			<div className='faq'>
				<div className='faq__serach'>
					<h3>Frequently Asked Questions</h3>
					<p>Browse througth the most Frequently asked questions</p>
					<FilterSearch />
				</div>
				<div className='faq__body'>
					<div className='faq__body__info scroll-bar'>
						{faq?.map((el, i) => (
							<Fragment key={i}>
								<div className='faq__body__question' onClick={() => setDownArrow(downArrow === i ? null : i)}>
									<h5>{el?.question}</h5>
									<img src={Images.downArrow} />
								</div>
								{downArrow === i && <p>{el?.answer}</p>}
								{faq?.length - 1 !== i && <hr></hr>}
							</Fragment>
						))}
					</div>
				</div>

				<div className='faq__bottom'>
					<h3> Still have Questions</h3>
					<p>can find the answer your looking for? Please contact to our support team</p>
					<span>
						<p className='faq__bottom__phoneno'>
							<img src={Images.contactus} alt='callus' width='25px' height='25px' />
							<a>+919876543210</a>
						</p>
						|
						<p className='faq__bottom__phoneno'>
							<img src={Images.contactus} alt='callus' width='25px' height='25px' />
							<a>abcd@gmail.com</a>
						</p>
					</span>
				</div>
			</div>
		</div>
	);
};

export default FAQ;
